export const PLAYBACK_RATE = [
    {
        label: '0.5X',
        value: '0.5',
    },
    {
        label: '1X',
        value: '1',
    },
    {
        label: '1.5X',
        value: '1.5',
    },
    {
        label: '2X',
        value: '2',
    },
];
